import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.modals_action.active,
    (active) => {
        return {
            active
        }
    }
)